export const fetchSettingCollaborators = data => ({
  type: "FETCH_SETTING_COLLABORATORS",
  payload: data
});

export const fetchCollaborator = data => ({
  type: "FETCH_COLLABORATOR",
  payload: data
});

export const initCollaborator = () => ({
  type: "INIT_COLLABORATOR"
});

export const setCollaboratorsSettingSuggestions = payload => ({
  type: "FETCH_COLLABORATOR_SETTING_SUGGESTIONS",
  payload
});

export const setCollaboratorSettingFilterTitle = title => {
  return {
    type: "SET_COLLABORATOR_SETTING_FILTER_TITLE",
    title
  };
};

export const updateSettingsCollaborator = resp => ({
  type: "UPDATE_SETTINGS_COLLABORATOR",
  payload: resp
});

export const setCollaboratorRegimes = data => ({
  type: "SET_COLLABORATOR_SUGGESTIONS_REGIMES",
  payload: data
});

export const deleteCollaboratorRegime = resp => ({
  type: "DELETE_COLLABORATOR_REGIME",
  payload: resp
});

export const saveCollaboratorRegime = resp => ({
  type: "SAVE_COLLABORATOR_REGIME",
  payload: resp
});

export const setCollaboratorRoles = data => ({
  type: "SET_COLLABORATOR_SUGGESTIONS_ROLES",
  payload: data
});

export const deleteCollaboratorRole = resp => ({
  type: "DELETE_COLLABORATOR_ROLE",
  payload: resp
});

export const saveCollaboratorRole = resp => ({
  type: "SAVE_COLLABORATOR_ROLE",
  payload: resp
});

export const setCollaboratorZones = data => ({
  type: "SET_COLLABORATOR_SUGGESTIONS_ZONES",
  payload: data
});

export const deleteCollaboratorZone = resp => ({
  type: "DELETE_COLLABORATOR_ZONE",
  payload: resp
});

export const saveCollaboratorZone = resp => ({
  type: "SAVE_COLLABORATOR_ZONE",
  payload: resp
});

export const setCollaboratorBus = data => ({
  type: "SET_COLLABORATOR_SUGGESTIONS_BU",
  payload: data
});

export const deleteCollaboratorBu = resp => ({
  type: "DELETE_COLLABORATOR_BU",
  payload: resp
});

export const saveCollaboratorBu = resp => ({
  type: "SAVE_COLLABORATOR_BU",
  payload: resp
});

export const setCollaboratorHolidayType = data => ({
  type: "SET_COLLABORATOR_SUGGESTIONS_HOLIDAY_TYPE",
  payload: data
});

export const deleteCollaboratorHolidayType = resp => ({
  type: "DELETE_COLLABORATOR_HOLIDAY_TYPE",
  payload: resp
});

export const saveCollaboratorHolidayType = resp => ({
  type: "SAVE_COLLABORATOR_HOLIDAY_TYPE",
  payload: resp
});

export const fetchCollaboratorAvatars = data => ({
  type: "FETCH_COLLABORATOR_AVATARS",
  payload: data
});

export const fetchDynamicTableCollaborators = data => ({
  type: "FETCH_DYNAMIC_TABLE_COLLABORATORS",
  payload: data
});

export const fetchGetGdNotifications = data => ({
  type: "FETCH_GD_NOTIFICATIONS",
  payload: data
});

export const setFilterZoneValue = zone => ({
  type: "SET_FILTER_ZONE",
  zone
});

export const setFilterBuValue = bu => ({
  type: "SET_FILTER_BU",
  bu
});

export const setFilterRegimeValue = regime => ({
  type: "SET_FILTER_REGIME",
  regime
});

export const setFilterRoleValue = role => ({
  type: "SET_FILTER_ROLE",
  role
});

export const filterCollaboratorsData = data => ({
  type: "FILTER_COLLABORATORS_DATA",
  payload: data
});



// WEBPACK FOOTER //
// ./src/actions/actions/collaborator.js